import { IntlShape } from "react-intl";

import { StandardDateRangeType } from "@mapmycustomers/shared/types/range/DateRange";
import DateRangeOptionGroup from "@mapmycustomers/shared/types/range/DateRangeOptionGroup";

import { DateRangeWithOffset } from "@app/component/input/dateRangeSelect/utils/rangesGenerator";
import DateRange from "@app/scene/reports/types/DateRange";

const getOptions = (
  intl: IntlShape,
  rangeType: StandardDateRangeType,
  rangesGenerator: Generator<DateRangeWithOffset>,
  getKey: (dateRange: DateRange) => string,
  getGroupLabel: (intl: IntlShape, range: DateRange) => string,
  getOptionLabel: (intl: IntlShape, range: DateRange) => string
): DateRangeOptionGroup[] =>
  Array.from(rangesGenerator).reduce<DateRangeOptionGroup[]>((result, range) => {
    const key = getKey(range);
    if (!result.length || result[result.length - 1].key !== key) {
      result.push({
        key,
        label: getGroupLabel(intl, range),
        options: [],
      });
    }
    result[result.length - 1].options.push({
      label: getOptionLabel(intl, range),
      value: `${rangeType}${range.offset}`,
    });
    return result;
  }, []);

export default getOptions;
